<script lang="ts">
  let { status }: { status: string } = $props()
</script>

<div class="gate-surface">
  <p class="gate-eyebrow">System Status</p>
  <p class="gate-title-sm">{status}</p>
  <p class="gate-muted">Gateway surface is reachable.</p>
</div>
